import { yupResolver } from "@hookform/resolvers/yup";
import FormInputMenu from "@repo/components/src/forms/menu";
import { Box } from "@repo/components/src/ui/box";
import { Card } from "@repo/components/src/ui/card";
import { HStack } from "@repo/components/src/ui/hstack";
import { Text } from "@repo/components/src/ui/text";
import { formatSeparators } from "@repo/components/src/utils/numbers";
import React from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import SharedInstagramStatistics from "../../shared/instagram";
import { ProfileBodyProps } from "../../types";

const instagramSchema = yup.object({
  instagram: yup.string().required(),
});

type InstagramSchema = yup.InferType<typeof instagramSchema>;

const ProfileInstagram = React.memo((props: ProfileBodyProps) => {
  const { user } = props;
  const instagramSet = user.instagramSet
    .slice()
    .sort()
    .reverse();
  const formProps = useForm<InstagramSchema>({
    resolver: yupResolver(instagramSchema),
    defaultValues: {
      instagram: instagramSet.find(() => true)?.id,
    },
  });
  const selectedInstagramId = formProps.watch("instagram");
  const selectedInstagram = instagramSet.find(
    (instagram) => instagram.id === selectedInstagramId,
  );
  if (!selectedInstagram) {
    const userFields = user;
    return (
      <Text action="muted">
        {userFields.firstName} no tiene una cuenta de Instagram conectada a
        Montu.
      </Text>
    );
  }
  return (
    <Box>
      {instagramSet.length > 1 && (
        <Card variant="outline" size="md" className="w-full rounded-xl mb-3">
          <HStack space="sm" className="items-center">
            <Text action="muted">
              Los datos que estás visualizando, corresponden a la siguiente
              cuenta de Instagram:
            </Text>
            <FormInputMenu
              control={formProps.control}
              name="instagram"
              placeholder="-"
              size="sm"
              buttonTriggerProps={{
                rounded: "lg",
                action: "muted",
                variant: "outline",
                className: "bg-background-50 px-2 h-6",
                size: "sm",
              }}
              headingProps={{
                bold: false,
                size: "xs",
              }}
              options={instagramSet.map((instagram) => ({
                label: formatSeparators(instagram.followers),
                value: instagram.id,
              }))}
            />
          </HStack>
        </Card>
      )}
      {selectedInstagram.accessTokenStatus ? (
        <SharedInstagramStatistics instagram={selectedInstagram} user={user} />
      ) : (
        <Text action="muted">
          La cuenta de Instagram @{selectedInstagram.username} no está conectada
          a Montu.
        </Text>
      )}
    </Box>
  );
});

ProfileInstagram.displayName = "ProfileInstagram";

export default ProfileInstagram;
